import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export type ExclamationIconProps = CreateIconComponentProps & {
  title?: string;
  viewBox?: string;
};

export const ExclamationIcon: React.FC<ExclamationIconProps> = ({
  title = 'ExclamationMark',
  viewBox = '0 0 16 16',
  ...props
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...props}>
    {/* prettier-ignore */}
    <g fillRule="evenodd"><path d="M0 0h16v16H0z" fill="none"/><path d="M8 .444a7.556 7.556 0 110 15.112A7.556 7.556 0 018 .444zm-.049 9.79a.848.848 0 00-.84.828c0 .456.384.84.84.84a.84.84 0 00.828-.84.838.838 0 00-.828-.828zm.756-6.456H7.171L7.4 9.322h1.092l.216-5.544z"/></g>
  </CreateIconComponent>
);

export default ExclamationIcon;
